<template>
  <div
    class="container-filter is-flex flex-direction--column"
    :class="{
      'container-filter--border': isExpand && bottomBorder,
      'bottom-padding': isExpand,
    }"
  >
    <div class="bottom-padding">
      <button class="filter-button button is-pulled-right"
        @click="toggleExpand"
        :title="!isExpand ? 'Expand Filter Options' : 'Collapse Filter Options'"
      >
        <span style="margin-right: 1rem">
          Filter Options
        </span>
        <font-awesome-icon
          v-if="!isExpand"
          :icon="['fal', 'caret-down']"
        />
        <font-awesome-icon
          v-if="isExpand"
          :icon="['fal', 'caret-up']"
        />
      </button>
    </div>
    <div v-show="isExpand">
      <slot name="filter-options"></slot>
    </div>
  </div>
</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCaretDown,
  faCaretUp,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faCaretDown,
  faCaretUp,
);
export default {
  props: {
    bottomBorder: {
      type: Boolean,
      default: true,
    },
    defaultExpanded: {
      type: Boolean,
    },
  },
  data() {
    return {
      isExpand: true,
    };
  },
  created() {
    this.isExpand = this.defaultExpanded;
  },
  methods: {
    toggleExpand() {
      this.isExpand = !this.isExpand;
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"
  @import "~bulma/sass/utilities/mixins"

  /deep/ .multi-dropdown-columns.columns
    flex-wrap: wrap
    .column
      flex: 1 0 auto
      width: auto
    .field
      .select
        width: 100%
        select
          width: 100%
    .column
      padding-right: 0
      .field
        padding-right: $column-gap
        border-right: 1px dashed #ccc
        @include until($tablet)
          border-right: none
        &.no-border
          border-right: none
        &.no-padding--right
          padding-right: 0px
      &.has-padding-right
        padding-right: $column-gap
    .column:last-child
      .field
        border-right: none
  .container-filter
    margin: 1rem
  .container-filter--border
    border-bottom: 1px solid #dee2e6
  .bottom-padding
    padding-bottom: 1rem
  .filter-button
    color: #5953a4
    background-color: #e9e9e9
    border: 1px solid #5953a4
  .columns
    flex-wrap: wrap
    .column
      flex: 1 0 auto
      width: auto
</style>
